import { Controller } from "@hotwired/stimulus"

// Пока картинка грузится, у неё висит класс is-loading — контейнер
// .kit-img-loader по нему показывает спиннер. Класс снимаем и при ошибке,
// чтобы спиннер не крутился вечно.
export default class extends Controller {
  connect() {
    this.done = this.done.bind(this)

    if (this.element.complete) {
      this.done()
    } else {
      this.element.addEventListener("load", this.done)
      this.element.addEventListener("error", this.done)
    }
  }

  disconnect() {
    this.element.removeEventListener("load", this.done)
    this.element.removeEventListener("error", this.done)
  }

  done() {
    this.element.classList.remove("is-loading")
  }
}
